import { AxiosInstance, AxiosRequestHeaders, InternalAxiosRequestConfig } from "axios";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";

const { sagSubscriptionKey } = useSagOptions();

export const sagAuthInterceptor = (config: InternalAxiosRequestConfig) => {
    config.headers ??= {} as AxiosRequestHeaders;
    config.headers["Ocp-Apim-Subscription-Key"] = sagSubscriptionKey;

    return config;
};

export const addSagAuthInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(sagAuthInterceptor, null, { synchronous: true });
};
